import React, { useMemo, useState } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import RegularButton from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import { DataGrid, esES } from '@material-ui/data-grid';
import Collapse from '@material-ui/core/Collapse';
import GridItem from 'components/Grid/GridItem';
import Delete from '@material-ui/icons/Delete';
import Table from 'components/Table/Table';
import { wsPost } from 'services/WService';
import { formatDate } from 'hooks/Pipe';
import { makeStyles } from '@material-ui/core/styles';


function DepositGroup(props) {
  const { group, index, deleteGroup, deleteItemFromGroup } = props;

  return (
    <GridItem key={group.id} xs={12} md={6}>
      <CardContainer icon={null}>
        <GridContainer>
          <GridItem xs={12}>
            <p>Grupo {index + 1}</p>
            <p>
              Cuenta destino: {group.CtaDestino} ({group.BanckAcct})
            </p>
            <p>
              Cuenta origen: {group.CtaOrigen} ({group.AllocAcct})
            </p>
            <p>Fecha de contabilización: {formatDate(group.DeposDate, 'F')}</p>
            <RegularButton
              justIcon
              round
              color="danger"
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
              }}
              onClick={() => deleteGroup(group)}
            >
              <Delete />
            </RegularButton>
          </GridItem>
          <GridItem xs={12}>
            <div style={{ height: '400px', overflow: 'auto' }}>
              <Table
                tableHead={[
                  '#',
                  'Fecha Depósito',
                  'Banco',
                  'Referencia (Nro Op)',
                  'Monto',
                  'Método pago',
                  'Descripción (Comentario)',
                  'Eliminar',
                ]}
                tableData={group.items.map((item, index) => {
                  return [
                    index + 1,
                    item.TaxDate,
                    item.DpsBank,
                    item.Ref2,
                    item.LocTotal,
                    item.U_SYP_MPPG,
                    item.Memo,
                    <RegularButton
                      justIcon
                      round
                      color="danger"
                      disabled={group.items.length <= 1}
                      onClick={() => deleteItemFromGroup(group, item)}
                    >
                      <Delete />
                    </RegularButton>,
                  ];
                })}
              />
            </div>
          </GridItem>
        </GridContainer>
      </CardContainer>
    </GridItem>
  );
}
  // Definir los estilos
  const useStyles = makeStyles(() => ({
    rowMismatch: {
      backgroundColor: '#ffebee !important',
      color: '#b71c1c !important',
      '&:hover': {
        backgroundColor: '#ffcdd2 !important', // Color al hacer hover
      }
    }
  }));
function ImportDeposits(props) {
  const classes = useStyles();
  const { importData = [], setImportData } = props;
  const { mismatchIds = new Set() } = props;
  const { selectionModel, setSelectionModel } = props;
  const { groups, setGroups } = props;
  const [procesing, setProcessing] = useState(false);
  const columns = [
    { field: 'TaxDate', headerName: 'Fecha Depósito', width: 140 },
    { field: 'DpsBank', headerName: 'Banco', width: 160 },
    { field: 'Ref2', headerName: 'Referencia (Nro Op)', width: 200 },
    { field: 'LocTotal', headerName: 'Monto', width: 150, sortable: false },
    { field: 'U_SYP_MPPG', headerName: 'Método pago', width: 150 },
    { field: 'Memo', headerName: 'Descripción (Comentario)', width: 280 },
    //
    // { field: 'BanckAcct', headerName: 'Cta Destino', width: 140 },
    // { field: 'AllocAcct', headerName: 'Cta Origen', width: 140 },
  ];

  function deleteDeposit(row) {
    setImportData((importData) => {
      let newImportData = [...importData];
      let index = newImportData.findIndex((item) => item.id === row.id);
      newImportData.splice(index, 1);
      return newImportData;
    });
  }

  function deleteGroup(group) {
    if (!window.confirm('¿Seguro de eliminar el grupo?')) return;

    setImportData((importData) => {
      let newImportData = [...importData];
      newImportData = newImportData.concat(group.items);
      newImportData.sort((a, b) => a.id - b.id);
      return newImportData;
    });

    setGroups((groups) => {
      let newGroups = [...groups];
      let index = newGroups.findIndex((item) => item.id === group.id);
      newGroups.splice(index, 1);
      return newGroups;
    });
  }

  function deleteItemFromGroup(group, item) {
    setImportData((importData) => {
      let newImportData = [...importData];
      newImportData.push(item);
      newImportData.sort((a, b) => a.id - b.id);
      return newImportData;
    });

    setGroups((groups) => {
      let newGroups = [...groups];
      let index = newGroups.findIndex((g) => g.id === group.id);
      let itemIndex = newGroups[index].items.findIndex((i) => i.id === item.id);
      newGroups[index].items.splice(itemIndex, 1);
      return newGroups;
    });
  }

  const gridColumns = useMemo(() => {
    columns.push({
      field: 'Acciones',
      headerName: 'Acciones',
      width: 75,
      renderCell: (params) => {
        return (
          <RegularButton
            justIcon
            round
            color="danger"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              deleteDeposit(params.row);
            }}
          >
            <Delete />
          </RegularButton>
        );
      },
    });

    return columns;
  }, [columns]);

  async function save() {
    setProcessing(true);
    let res = await wsPost('pymt/deposit/massive-store', {
      groups,
    });

    if (res.success) {
      alert(res.message);
      window.location.href = '/admin/bancos/operaciones/depositos/';
    } else {
      setProcessing(false);
      alert(res.message);
    }
  }

  return (
    <>
      <Collapse in={!(importData.length === 0)}>
        <CardContainer icon={null}>
          <GridItem xs={12} style={{ height: '500px' }}>
            <DataGrid
              selectionModel={selectionModel}
              onSelectionModelChange={setSelectionModel}
              localeText={esES.props.MuiDataGrid.localeText}
              columns={gridColumns}
              rows={importData}
              checkboxSelection
              disableColumnFilter
              disableColumnMenu
              disableColumnReorder
              getRowClassName={(params) => 
                mismatchIds.has(params.id) ? classes.rowMismatch : ''
              }
            />
          </GridItem>
        </CardContainer>
      </Collapse>

      {groups.length > 0 && (
        <>
          <GridContainer>
            {groups.map((group, index) => {
              return (
                <DepositGroup
                  group={group}
                  index={index}
                  deleteGroup={deleteGroup}
                  deleteItemFromGroup={deleteItemFromGroup}
                />
              );
            })}
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} xl={2}>
              <RegularButton
                color="success"
                disabled={procesing || importData.length > 0}
                onClick={save}
              >
                Procesar
              </RegularButton>
            </GridItem>
          </GridContainer>
        </>
      )}
    </>
  );
}

export default ImportDeposits;
